<div class="flex flex-wrap gap-2">
    <div class="timeslot-item-container" *ngFor="let item of hours;">
        <button [disabled]="hourFilter(item)" class="timeslot-item" type="button" (click)="hourChanged(item)" [ngClass]="{selected: checkSelectedHour(item), disabled: hourFilter(item)}">
            <div class="title">{{item | number: '2.0-0' }}:00</div>
        </button>
    </div>
</div>

<!-- <div dir="ltr" class="flex flex-row items-center"> -->
    <!-- <mat-select placeholder="HH" [value]="timeValue?.getHours()" (selectionChange)="hourChanged($event.value)">
        <mat-option *ngFor="let item of hours;" [value]="item" [disabled]="hourFilter(item)">{{item | number: '2.0-0' }}:00</mat-option>
    </mat-select> -->
    <!-- <mat-select placeholder="MM" [value]="timeValue?.getMinutes()" style="width: 37px;" (selectionChange)="minuteChanged($event.value)">
        <mat-option *ngFor="let item of minutes;" [value]="item" [disabled]="minuteFilter(item)">{{ item | number: '2.0-0' }}</mat-option>
    </mat-select> -->
<!-- </div> -->



